'use client';

import { useContext } from 'react';
import type { PaletteKey } from '../tokens/types';
import { ThemeContext } from './ThemeContext';

export interface UsePaletteResult {
  readonly palette: PaletteKey;
  readonly setPalette: (key: PaletteKey) => void;
}

/**
 * Read and change the current palette key. Use to wire a theme switcher
 * (light/dark toggle, men's/women's section, etc.).
 */
export function usePalette(): UsePaletteResult {
  const { palette, setPalette } = useContext(ThemeContext);
  return { palette, setPalette };
}
